/**
 * taskBadgeState — Pure Function (Phase 4 Plan 01, TASK-03).
 *
 * Entscheidet ob eine Lead-Karte den heute-faellig-Badge bekommt.
 * Regel: Karte hat mindestens einen offenen Task (completedAt = null) der
 * HEUTE oder FRUEHER faellig ist. Ueberfaellige Tasks (dueDate < today) zaehlen
 * als "heute zu erledigen".
 *
 * Pure: now ist Argument, testbar mit fixen Zeitstempeln.
 */

import type { LeadTask } from '../types';

export function taskBadgeState(
  tasks: LeadTask[] | undefined,
  now: Date = new Date(),
): boolean {
  if (!tasks || tasks.length === 0) return false;
  const todayIso = now.toISOString().slice(0, 10); // yyyy-MM-dd
  for (const t of tasks) {
    if (t.completedAt) continue;
    if (!t.dueDate) continue;
    if (t.dueDate <= todayIso) return true;
  }
  return false;
}
